<glxy-empty-state class="upgrade-empty-state">
  <div class="upgrade-content">
    <glxy-empty-state-title>
      {{ 'RECORDING_UPGRADE.TITLE' | translate }}
    </glxy-empty-state-title>

    <p class="upgrade-description">
      {{ 'RECORDING_UPGRADE.DESCRIPTION' | translate }}
    </p>

    <ul class="benefits-list">
      @for (benefit of benefits; track benefit) {
        <li>
          <mat-icon>check_circle_outline</mat-icon>
          {{ benefit | translate }}
        </li>
      }
    </ul>

    <glxy-empty-state-actions class="upgrade-actions">
      <a mat-flat-button color="primary" routerLink="/upgrade">
        {{ 'RECORDING_UPGRADE.UPGRADE_PLAN' | translate }}
        <mat-icon iconPositionEnd>arrow_circle_up</mat-icon>
      </a>
      <a mat-stroked-button color="primary" [href]="learnMoreUrl" target="_blank">
        {{ 'RECORDING_UPGRADE.LEARN_MORE' | translate }}
        <mat-icon iconPositionEnd>open_in_new</mat-icon>
      </a>
    </glxy-empty-state-actions>

    <p class="contact-info">
      {{ 'RECORDING_UPGRADE.CONTACT_PREFIX' | translate }}
      <a href="tel:1-306-955-5512">1-306-955-5512</a>
    </p>
  </div>
  <glxy-empty-state-hero class="upgrade-hero">
    <img [src]="emptyStateImageUrl" />
  </glxy-empty-state-hero>
</glxy-empty-state>
